import React from 'preact';
import App from './components/App.jsx';

React.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./client/index.js